import { render, staticRenderFns } from "./ModalCatalogo.vue?vue&type=template&id=3cee973c&scoped=true"
import script from "./ModalCatalogo.vue?vue&type=script&lang=js"
export * from "./ModalCatalogo.vue?vue&type=script&lang=js"
import style0 from "./ModalCatalogo.vue?vue&type=style&index=0&id=3cee973c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cee973c",
  null
  
)

export default component.exports